<div class="row">
    <div class="col-lg-7">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [addText]="'Add New'"
                        [customAddText]="'Select'"
                        [customActionComponent]="this"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [minHeight]="70"
                    (initialized)="grid.initialize(mainGrid)"
                    [itemFormatter]="gridItemFormatter"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                    (beginningEdit)="beginningEdit()"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Who'"
                        [binding]="'userId'"
                        [dataMap]="allUserMap"
                        [width]="75"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="' '" [binding]="'isHot'" [width]="50" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                            <div style="text-align: center; cursor: pointer" (click)="toggleHot(cell)">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                            </div>
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="' '" [binding]="'isRecurring'" [width]="40" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                            @if (cell.item.isRecurring) {
                                <div style="text-align: center" [title]="recurringTooltip(cell.item)">
                                    <fa-icon [icon]="faRepeat"></fa-icon>
                                </div>
                            }
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Due'" [binding]="'dueDate'" [width]="105"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'To-Do'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Done'"
                        [binding]="'doneDate'"
                        [width]="125"
                        [editor]="inputDate"
                        [isRequired]="false"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
                <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
            </div>
        </div>
    </div>

    <div class="col-lg-5" appAutoSize [minHeight]="100">
        @if (grid.selectedItem) {
            <div class="h-100 d-flex flex-column">
                <h5 class="text-truncate text-muted" style="margin-bottom: 15px">Details for "{{ grid.selectedItem?.name }}"</h5>
                <div class="flex-grow-1" style="min-height: 0">
                    <quill-view
                        style="display: block; height: 100%"
                        [content]="grid.selectedItem?.details ?? 'No Details'"
                        theme="snow"
                    ></quill-view>
                </div>
            </div>
        } @else {
            <div
                class="d-flex align-items-center justify-content-center h-100"
                [style.visibility]="isInitialLoading ? 'hidden' : 'visible'"
            >
                <div class="text-center">
                    <div class="mb-3">
                        <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                    </div>
                    <h5 class="text-muted mb-2">No To-Do Selected</h5>
                    <p class="text-muted mb-0">Select a to-do from the list to view its details</p>
                </div>
            </div>
        }
    </div>
</div>
